var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InPageNav',{attrs:{"options":[
				{
					text : 'Manage organisations',
					path : '/orgs',
				},
				{
					text : 'Profile settings',
					path : '/settings',
				} ]}})}
var staticRenderFns = []

export { render, staticRenderFns }